import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './event-list-x2.component.scss';
var EventListX2 = /** @class */ (function (_super) {
    tslib_1.__extends(EventListX2, _super);
    function EventListX2(element) {
        return _super.call(this, element) || this;
    }
    EventListX2.prototype.init = function () {
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.windowWidth = document.documentElement.clientWidth;
        switch (this.sliderItems) {
            case 1:
                this.breakpoints = {};
                break;
            case 2:
                this.breakpoints = {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                    },
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                    }
                };
                break;
            default:
                this.breakpoints = {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                    },
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                    }
                };
                break;
        }
        this.sliderConfig = {
            slidesPerView: this.sliderItems,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    EventListX2.prototype.bindEvents = function () { };
    return EventListX2;
}(Base));
export { EventListX2 };



//////////////////
// WEBPACK FOOTER
// ./components/event-list-x2/event-list-x2.component.ts
// module id = 273
// module chunks = 0